import Gallery from "../../../components/Gallery/Gallery";
import StarsRate from "../../../components/StarsRate/StarsRate";
import "../ProductPage.css";
import { BsCart } from "react-icons/bs";
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  addToCart,
  decreaseQuantity,
  increaseQuantity,
} from "../../../redux/reducers/cart";
import { Button } from "react-bootstrap";

const ProductOverView = (props) => {
  const { product, wholesale } = props;
  const [gallery, setGallery] = useState([
    "https://picsum.photos/id/1018/1000/600/",
    "data:image/jpeg;base64,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",
    "https://picsum.photos/id/1018/1000/600/",
    "https://picsum.photos/id/1018/1000/600/",
    "https://picsum.photos/id/1018/1000/600/",
    "https://picsum.photos/id/1018/1000/600/",
  ]);
  const [quantity, setQuantity] = useState(0);
  const dispatch = useDispatch();
  const cart = useSelector((state) => state?.cart?.productsCart);

  useEffect(() => {
    if (product?.csv) {
      if (product?.images?.length > 0) {
        let copyGallery = [];
        product?.images?.map((item) => {
          item?.image && copyGallery?.push(item?.image);
        });
        setGallery(copyGallery);
      }
    } else {
      if (product?.gallery?.length > 0) {
        let copyGallery = [];
        product?.gallery?.map((item) => {
          item?.image && copyGallery?.push(item?.image);
        });
        setGallery(copyGallery);
      }
    }
  }, [product]);

  useEffect(() => {
    const itemInCart = cart?.find((cartItem) => cartItem?.id === product?.id);
    itemInCart ? setQuantity(itemInCart?.quantity) : setQuantity(0);
  }, [cart, product]);

  //functions
  const HandleAddToCart = (e) => {
    e.preventDefault();
    dispatch(
      addToCart({
        id: product?.id,
        title: product?.title,
        stock: product?.skus?.[0]?.stock,
        slug: product?.slug,
        price: product?.price,
        unit: product?.unit,
        company: product?.company,
        gallery: product?.gallery,
        tag: product?.tag,
        sku: product?.skus?.[0],
        type: "products",
      })
    );
  };

  const HandleIncreaseQuantity = (e) => {
    e.preventDefault();
    dispatch(
      increaseQuantity({ id: product?.id, stock: product?.skus?.[0]?.stock })
    );
  };
  const HandleDecreaseQuantity = (e) => {
    e.preventDefault();
    dispatch(decreaseQuantity({ id: product?.id }));
  };

  return (
    <>
      <div className="row px-md-4 px-2">
        <div className="col-lg-6 mb-lg-0 mb-3">
          <Gallery gallery={gallery} />
        </div>
        <div className="col-lg-6">
          <span className="cat-title">{product?.category?.[0]?.title} -</span>
          <span className="cat-title">
            {" "}
            {product?.category?.[0]?.parent?.title}
          </span>
          <h1 className="product-title my-2">{product?.title}</h1>
          <Link
            to={`/supplierstore/${product?.company?.slug}`}
            className="cat-title fs-5 d-block"
            style={{ width: "fit-content" }}
          >
            {product?.company?.company_name}
          </Link>{" "}
          <br />
          <StarsRate num={product?.rating_avg} />
          <p className="my-4">
            {product?.description
              ? product?.description
              : "There's no description"}
          </p>
          <h2 className="product-title" style={{ fontWeight: "bold" }}>
            {!wholesale && product?.skus?.[0]?.price}{" "}
            {!wholesale && product?.skus?.[0]?.price_currency}{" "}
            {!wholesale && product?.unit === "unit"
              ? ""
              : !wholesale && `per ${product?.unit}`}
          </h2>
          <div className="d-flex flex-wrap gap-3 mt-4">
            <p className="m-0 quntity-box py-2 px-4 d-flex align-items-center">
              Quantity : {product?.skus?.[0]?.stock}{" "}
              {product?.unit === "unit" ? "" : product?.unit}
            </p>
            {
              quantity == 0 ? 
              !wholesale && (
                <button
                  id="btn-box"
                  className="btn  text-light d-flex justify-content-center align-items-center"
                  onClick={HandleAddToCart}
                >
                  Add to cart <BsCart size={15} className="mx-2" />{" "}
                </button>
              )
              : 
              <>
							<div
								className='d-flex justify-content-center align-items-center gap-3'
								onClick={(e) => e.preventDefault()}
							>
								<Button
									className='btn text-decoration-none'
									style={{
										backgroundColor: "var(--blue)",
									}}
									onClick={(e) => HandleDecreaseQuantity(e)}
								>
									-
								</Button>
								<p className='text-center position-relative p-0 m-0'>
									{quantity}
								</p>
								<Button
									className='btn text-decoration-none'
									style={{
										backgroundColor: "var(--blue)",
									}}
									onClick={(e) => HandleIncreaseQuantity(e)}
								>
									+
								</Button>
							</div>
						</>
            }
            {/* {!wholesale && (
              <button
                id="btn-box"
                className="btn  text-light d-flex justify-content-center align-items-center"
                onClick={HandleAddToCart}
              >
                Add to cart <BsCart size={15} className="mx-2" />{" "}
              </button>
            )} */}
          </div>
        </div>
      </div>
    </>
  );
};

export default ProductOverView;
